import { t } from 'i18next';
import DataGridWrapper from '@/core/wrappers/data-grid-wrapper';
import CustomStore from 'devextreme/data/custom_store';
import React, { useCallback, useRef, useState } from 'react';
import { documentTemplateService } from '../../services/document-template';
import { useNavigate } from 'react-router-dom';
import { DataGrid, Popup, ScrollView } from 'devextreme-react';
import { RemoveMessage } from '@/core/helper/validation-rule-helper';
import { createCustomStore } from '@/core/wrappers/custom-store-wrapper';


const DocumentTemplateList = () => {
    const dataGridRef = useRef<DataGrid>(null);
    const [popupVisible, setPopupVisible] = useState(false);
    const [selectedTemplate, setSelectedTemplate] = useState<any>(undefined);
    const [mainStore] = useState(() => createCustomStore({
        key: "id",
        load: documentTemplateService.getListAsync,
        remove: (key) => {
            return documentTemplateService.deleteAsync(`${key}`);
        },
    }));
    const onPopupHiding = useCallback(() => {
        setPopupVisible(false);
    }, [setPopupVisible]);

    const showProductInfo = useCallback((e: any) => {
        setPopupVisible(true);
        setSelectedTemplate(e.row.data.template)
        console.log(e.row.data.template);
    }, [setPopupVisible, setSelectedTemplate]);

    const navigate = useNavigate();

    const goToEdit = (id: string) => {
        navigate(`/admin/document-template-definition/${id}`, { state: { id: id } })
    }

    return (

        <React.Fragment>
            <DataGridWrapper
                props={{ id: 'document-template-list', ref: dataGridRef }}
                permissonCode='Admin.DocumentTemplate.DocumentTemplate'
                datasource={mainStore}
                pagerVisible={true}
                filterVisible={true}
                headerFilterVisible={true}
                enableCustomToolbarContent={true}
                editingConfig={{ allowUpdating: true, allowDeleting: true, confirmDeleteMessage: RemoveMessage(t('name')) }}
                navigateNewRecordPath='/admin/document-template-definition'
                columns={[
                    {
                        dataField: 'name',
                        caption: t('name'),
                        allowSearch: true,
                    },
                ]}
                buttonConfig={[
                    {
                        name: 'edit',
                        icon: 'eyeopen',
                        onClick: showProductInfo
                    },
                    {
                        name: 'edit',
                        icon: 'edit',
                        onClick: function (e: any) {
                            goToEdit(e.row?.data.id);
                        },
                    },
                    {
                        name: 'delete',
                        icon: 'trash',
                    },
                ]}
            />
            <Popup
                visible={popupVisible}
                onHiding={onPopupHiding}
                showTitle={true}
                width={900}
                height={520}
                position={{
                    of: window,
                    at: 'center',
                    my: 'center'
                }}
                title={t("template")}
            >
                <ScrollView height={250}>
                    <div className="table-responsive">
                        {popupVisible && selectedTemplate}
                    </div>
                </ScrollView>

            </Popup>
        </React.Fragment>
    )
}
export default DocumentTemplateList